import React from 'react';

import { Button, Media } from './styles';

type Props = {
  children?: React.ReactNode;
  media: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  url?: string;
};

export const MediaButton = (props: Props) => {
  const { children, className, url, onClick, media } = props;

  return (
    <Button className={className} to={url} onClick={onClick}>
      <Media>{media}</Media>

      {children}
    </Button>
  );
};
